import { AgColDefsI, AgGridI } from "../../../../../shared/common-components/ag-grid/ag-grid.model";
import { CheckboxRendererComponent } from "../../../../../shared/common-components/ag-grid/checkbox-renderer/checkbox-renderer.component";
import { TextRendererComponent } from "../../../../../shared/common-components/ag-grid/text-renderer/text-renderer.component";

export class CloneProduct {
}

const NameColumn: AgColDefsI = {
    headerName: "Name",
    headerClass: "px-0 custom-column-group-cell",
    field: "name",
    sortable: true,
    cellRenderer: TextRendererComponent,
    cellRendererParams: { isCursor: true },
    cellClass: "custom-column-group-cell ",
    minWidth: 200,
    editable: false,
};

const ShortCode: AgColDefsI = {
    headerName: "Short Code",
    headerClass: "px-0 custom-column-group-cell",
    field: "extra1",
    sortable: true,
    cellRenderer: TextRendererComponent,
    cellRendererParams: { isCursor: true },
    cellClass: "custom-column-group-cell ",
    minWidth: 100,
    editable: false,
};

const ActionColumn: AgColDefsI = {
    headerName: "",
    headerComponentParams: { selectAll : true },
    field: "active",       
    lockPosition: "left",
    cellClass: "ag-header-check-center",
    cellRenderer:CheckboxRendererComponent,
    cellRendererParams: { showLabel: false}, 
    headerClass:"ag-header-check-center custom-column-group-cell",
    minWidth: 60,
    maxWidth: 60,
    editable:false, 
  };


export const ColDefs: AgColDefsI[] = [
    NameColumn,
    ShortCode,
    ActionColumn
];

export const AgGridDataModel: AgGridI = {
    colDefs: ColDefs,
    rowSelection: "multiple",
    columnSettings: true,
    selectAll : true,
    rows: [],
    headerHeight: 28,
    rowHeight: 28,
};